import { render, staticRenderFns } from "./EventEditLayout.vue?vue&type=template&id=546eae2f&scoped=true"
import script from "./EventEditLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventEditLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventEditLayout.vue?vue&type=style&index=0&id=546eae2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546eae2f",
  null
  
)

export default component.exports